/**
 * TT-02 — TanStack Query keys for the time-tracking feature.
 *
 * `all` is the invalidation root: a create / edit / delete / lock invalidates
 * it wholesale, because any of those can move a row between the "my list",
 * the review table and the totals in one go.
 */
import type { TimeTrackingListFilters } from "./types.js";

export const timeTrackingKeys = {
  all: ["time-tracking"] as const,
  lists: () => [...timeTrackingKeys.all, "list"] as const,
  list: (filters: TimeTrackingListFilters) =>
    [...timeTrackingKeys.lists(), filters] as const,
  myContext: () => [...timeTrackingKeys.all, "my-context"] as const,
  configs: () => [...timeTrackingKeys.all, "config"] as const,
  config: (projectId: string) =>
    [...timeTrackingKeys.configs(), projectId] as const,
};
